import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";

export default function BlogPost() {
  const { slug } = useParams();
  const [p, setP] = useState(null);

  useEffect(() => { api.get(`/blog/${slug}`).then((r) => setP(r.data)).catch(() => setP(false)); }, [slug]);

  if (p === null) return <div className="container-editorial py-24">Loading…</div>;
  if (!p) return <div className="container-editorial py-24"><h1 className="font-serif text-4xl">Not found</h1></div>;

  return (
    <div data-testid="page-blog-post" className="bg-[#F9F8F6]">
      <section className="container-editorial pt-16 md:pt-24 pb-8 max-w-4xl">
        <div className="text-[10px] uppercase tracking-[0.32em] text-[#A85C42] mb-6"><Link to="/blog" className="hover:text-[#2B2927]">Journal</Link> · {p.category}</div>
        <h1 className="font-serif text-4xl md:text-6xl tracking-tight leading-[1.02]">{p.title}</h1>
        <div className="mt-6 text-sm text-[#7A736C]">By {p.author} · {new Date(p.published_at || Date.now()).toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" })}</div>
      </section>
      {p.cover_image && (
        <section className="container-editorial pb-10 max-w-5xl">
          <img src={p.cover_image} alt={p.title} className="w-full aspect-[16/9] object-cover rounded-sm" />
        </section>
      )}
      <section className="container-editorial pb-24 max-w-3xl">
        <div className="prose prose-lg max-w-none text-[#2B2927] leading-relaxed [&>p]:mb-6 [&>p]:text-[17px]" dangerouslySetInnerHTML={{ __html: p.content }} />
      </section>
    </div>
  );
}
